<template>
  <div>
    <v-card :style="cardStyling">
      <h4 class="text-uppercase text-center py-4" :class="titleClass">{{ title }}</h4>
      <h5 v-if="subTitle" class="text-center">{{subTitle}}</h5>
      <v-container>
        <slot name="content"></slot>
      </v-container>
      <v-card-actions class="justify-center">
        <v-btn
          v-for="action in actions"
          v-show="evaluateCondition(action.show, true)"
          :color="action.color || 'primary'"
          :class="action.class"
          :style="action.style"
          :loading="evaluateCondition(action.loading)"
          :disabled="evaluateCondition(action.loading)"
          :key="action.label"
          @click="action.action"
        >
          {{ action.label }}
          <v-icon v-if="action.icon" right>
            {{ action.icon }}
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
/**
 * @typedef {Object} Action
 * @property {?bool|Function} show
 * @property {?string} color
 * @property {?string|Object} class
 * @property {?string|Object} style
 * @property {?bool|Function} loading
 * @property {?Function} action
 */
export default {
  props: {
    title: {type: String, required: true},
    /** @type {Array<Action>} */
    actions: {type: Array, required: true},
    subTitle: String,
    titleClass: [String, Object],
    cardStyling: [String, Object],
  },
  name: "BaseDialog",
  methods: {
    evaluateCondition(value, defaultValue = null) {
      if (value == null) {
        return defaultValue;
      }

      if (typeof value === 'function') {
        return value();
      }

      return Boolean(value);
    }
  },
};
</script>

<style scoped>

</style>
